import { Injectable } from '@angular/core';

import type { DynamicFormConfig } from '@core/ask-hr-dynamic-forms-types';

import { injectDynamicFormConfigs } from './form-kinds/types';

@Injectable()
export class DynamicFormConfigService {
  public configs: DynamicFormConfig[] = injectDynamicFormConfigs().map(config => new config());
  public configsMap = Object.fromEntries(this.configs.map(config => [config.kind, config]));

  public defineAvailableConfigs = this.configs.map(config => ({
    option: config.defineConfig.name,
    value: config.kind,
    icon: config.defineConfig.icon,
  }));
}
